"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class ApplicationService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getApplicationList(fetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = localStorage.getItem('access_token');
                let header = (0, utils_1.getHeader)(token);
                const response = yield axios_1.default.get(`${this.baseUrl}application/admin/list?page=${fetchPayload.pageNumber}&limit=${fetchPayload.limit}`, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
    createApplication(createPayLoad) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = localStorage.getItem('access_token');
                let header = (0, utils_1.getHeader)(token);
                createPayLoad = JSONbig.stringify(createPayLoad);
                const response = yield axios_1.default.post(`${this.baseUrl}application/admin/create`, createPayLoad, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    updateApplication(createPayLoad) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = localStorage.getItem('access_token');
                let header = (0, utils_1.getHeader)(token);
                createPayLoad = JSONbig.stringify(createPayLoad);
                const response = yield axios_1.default.put(`${this.baseUrl}application/admin/edit`, createPayLoad, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
}
exports.ApplicationService = ApplicationService;
